// @flow
import React from 'react'

const ArrowDown = () => {
  return (
    <svg width="12" height="7" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M14 12H-2V-4h16z" />
        <path
          stroke="#4A5665"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.5 1L6 5.5 1.5 1"
        />
      </g>
    </svg>
  )
}

export default ArrowDown



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowDown.js